<template>
    <div class="coreDriverBox">
        <!-- <div class="chainTitle">核心驱动</div> -->
        <div v-if="coreDriver.length>0" :class="!isClickFlag?'box':'box showRight'">
            <div  id="mainDriver" class="main" style="width: 100%;height:100%;"></div>
            <div class="boxRight" v-if="isClickFlag">
                <div class="lineBotton">
                    <div id="mainDataLine" class="main" style="width: 100%;height:100%;"></div>
                </div>
            </div>
        </div>
        <DataEmpty v-if="coreDriver.length==0&&isEnd"></DataEmpty>

    </div>
</template>

<script>
  import {mapState} from 'vuex'
  import DataEmpty from '../dataEmpty.vue'
  import baseUrl from '@/utils/setting'
  export default {
    name: 'coreDriver',
    data() {
        return {
            coreDriver: {},
            isClickFlag : false,
            paramsInfo:{},
            isEnd:false
        }
    },
    computed: {...mapState(['productShowInfo','productRouterInfo','colorArr'])},
    components:{ DataEmpty },
    created(){
        let coCode = this.productRouterInfo.coCode
        this.paramsInfo = this.productRouterInfo
        this.getCompanyCoreDrive(coCode);
    },
    methods: {
        //获取核心驱动
        getCompanyCoreDrive(coCode){
            this.isEnd = false
            this.$store.dispatch('getCompanyCoreDrive',{coCode:coCode}).then( res => {
                this.isEnd = true
                if( res.status == 200 ){
                    this.coreDriver = res.data.data
                    if(this.coreDriver.length>0){
                        this.showGraph();
                    }
                }
            })
        },
        //展示关系图
        showGraph(){
            let that = this,elList=[],myChart = [],data = [],links = [];
            let color = ['#55787f', '#787d60', '#ca9f51', '#87919e', '#4d8d7a', '#667c92', '#996b6b', '#a08db4', '#bcbcbb', '#b1b594', '#a49f95', '#ac7a79', '#99a590', '#9cabbd', '#748596', '#6f8765', '#706777', '#82778d', '#baac92', '#919382']
            data.push({
                    value : that.paramsInfo.name,
                    name : that.paramsInfo.name,
                    symbolSize : 50,
                    draggable: true,
                    code : that.paramsInfo.coCode,
                    itemStyle: {
                        normal: {
                            color: that.colorArr[0]
                        }
                    }
            })
            this.coreDriver.forEach(function( item,index ){
                data.push({
                    value : item.driveName,
                    name : item.driveName,
                    symbolSize : item.driveSort <= 4 ? 20 + (4-item.driveSort) * 10 : 20,
                    draggable: true,
                    code : item.seriesCode,
                    tips : item.tips,
                    itemStyle: {
                        normal: {
                            // color: that.colorArr[item.driveType]
                            color: color[index]
                        }
                    }

                })
                links.push({
                        source:  that.paramsInfo.name,
                        target:  item.driveName
                })
            })
            var option = {
                title: {text: ''},
                tooltip: {
                    show: true,
                    trigger: 'item'
                },
                animation:false,
                animationEasingUpdate: 'quinticInOut',
                series: [
                {
                    type: 'graph',
                    layout: 'force',
                    symbol: 'circle',
                    symbolSize: 30,
                    draggable: true,
                    roam: true,
                    label: {
                        normal: {
                            show: true,
                            fontWeight: 500,
                            fontSize: 16,
                            position:'top',
                            color:'#333',
                        }
                    },
                    force: {
                        // 力引导布局相关的配置项，力引导布局是模拟弹簧电荷模型在每两个节点之间添加一个斥力，每条边的两个节点之间添加一个引力，每次迭代节点会在各个斥力和引力的作用下移动位置，多次迭代后节点会静止在一个受力平衡的位置，达到整个模型的能量最小化。
                        // 力引导布局的结果有良好的对称性和局部聚合性，也比较美观。
                        repulsion: 845, // [ default: 50 ]节点之间的斥力因子(关系对象之间的距离)。支持设置成数组表达斥力的范围，此时不同大小的值会线性映射到不同的斥力。值越大则斥力越大
                        edgeLength: 155 // [ default: 30 ]边的两个节点之间的距离(关系对象连接线两端对象的距离,会根据关系对象值得大小来判断距离的大小)，
                        // 这个距离也会受 repulsion。支持设置成数组表达边长的范围，此时不同大小的值会线性映射到不同的长度。值越小则长度越长。如下示例:
                        // 值最大的边长度会趋向于 10，值最小的边长度会趋向于 50      edgeLength: [10, 50]
                    },
                    edgeSymbol: ['circle', 'arrow'],
                    edgeSymbolSize: [4, 10],
                    data: data,
                    // tooltip: {
                    //         formatter: '{b}',
                    //         backgroundColor: 'rgba(50,50,50,0.8)'
                    // },
                    tooltip: {
                        // formatter: '{b}',
                        formatter: function(params){//触发之后返回的参数，这个函数是关键
                            // console.log(params);
                            if ( params.data.tips  ) {//如果触发节点
                                return  params.data.tips;//返回标签
                            }else {
                                return  params.data.name;
                            }
                            // if (params.data.category !=undefined) {//如果触发节点
                            // return params.data.remark;//返回标签
                            // }
                        },
                        backgroundColor: 'rgba(50,50,50,0.8)'
                    },
                    links: links,
                    lineStyle: {
                        normal: {
                            opacity: 0.5,
                            width: 1,
                            curveness: 0
                        }
                    }
                }
                ]
            };
            // 基于准备好的dom，初始化echarts实例
            this.$nextTick(function(){
                myChart = that.$echarts.init( document.getElementById('mainDriver'))
                myChart.setOption(option);
                myChart.on('click', function (params) {
                    if(params.data.source&&params.data.target){
                        return;
                    }
                    if( params.data.name == that.productShowInfo.name){
                        that.isClickFlag = false;
                        return;
                    }

                    that.isClickFlag = true
                    that.showLine(params.data.code)
                });
            })
        },
        //展示折线图
        showLine(seriesCode){
            let that = this,maxMinVal = {};
            this.$store.dispatch('getCompanyCoreDriveSeriesData',{seriesCode:seriesCode}).then( res => {
                let seriesDataRet = res.data.data.list
                maxMinVal.min = res.data.data.minValue;
                maxMinVal.max = res.data.data.maxValue;
                if(seriesDataRet&&seriesDataRet.length>0){
                  let myChart = that.$echarts.init(document.getElementById('mainDataLine'));
                  let xData = [],seriesData = []
                  seriesDataRet.forEach(function(item){
                      xData.push(item.dataTime.split(' ')[0]),
                      seriesData.push(item.dataValue)
                  })
                  let seriesName = seriesDataRet[0].seriesName
                  let seriesCode = seriesDataRet[0].seriesCode
                  let option = {
                        title: {
                            left: 'center',
                            text: seriesName,
                            subtext: '下载数据',
                            sublink: baseUrl+'/user/downLoadSeriesData?seriesCode='+seriesCode+'&Authorization='+sessionStorage.getItem('authToken'),
                            subtarget:"blank",
                            subtextStyle:{//副标题内容的样式
                              color: '#d16c5d',
                              fontStyle:'normal',//主标题文字字体风格，默认normal，有italic(斜体),oblique(斜体)
                              fontWeight:"bold",//可选normal(正常)，bold(加粗)，bolder(加粗)，lighter(变细)，100|200|300|400|500...
                              fontFamily:"san-serif",//主题文字字体，默认微软雅黑
                              fontSize:12//主题文字字体大小，默认为12px
                            },
                        },
                        tooltip: {
                            trigger: 'axis',
                            formatter: function (params) {
                                params = params[0];
                                return params.value+'<br />'+params.name;
                            },
                            axisPointer: {
                                animation: false
                            }
                        },
                        grid : {
                            containLabel:true
                        },
                        xAxis: {
                            type: 'category',
                            data: xData,
                            splitNumber:5,
                            axisLabel:{
                                rotate:30,
                            }
                        },
                        yAxis: {
                            type: 'value',
                            min: parseInt(maxMinVal.min<0?maxMinVal.min*1.2:maxMinVal.min*0.8),
                            max: parseInt(maxMinVal.max<0?maxMinVal.max*0.8:maxMinVal.max*1.2),
                            splitNumber:8
                        },
                        series: [{
                            name: seriesName,
                            type:'line',
                            data:seriesData
                        }]
                  };
                  myChart.setOption(option)
                }else{
                    this.isClickFlag = false
                }
            })
        }
    },
    mounted() {},
    // watch:{
    //     productRouterInfo:{
    //         handler(newVla, oldVal) {
    //             if( this.paramsInfo.name != this.productRouterInfo.name){
    //                 let coCode = this.productRouterInfo.coCode
    //                 this.paramsInfo = this.productRouterInfo
    //                 this.getCompanyCoreDrive(coCode);
    //             }
    //         },
    //         deep: true
    //     }
    // }
  }
</script>

<style lang="scss" src="../../../sass/productInfo/coreDriver.scss"></style>



// WEBPACK FOOTER //
// src/components/productInfoComponents/companyCom/coreDriver.vue